import loadjs from "loadjs";
import WindowFunc from "../wea-tools/window";

// 获取 window
const getCurrentWindow = () => {
  // if (this.state.hasSetWindow) {
  //   return window["setUploadWindow" + this.state.containerId];
  // }
  return WindowFunc.getParent() !== window &&
    this &&
    this.refs &&
    $(this.refs.wrap).closest(".ant-modal").length > 0
    ? WindowFunc.getTop()
    : window;
  // return WindowFunc.getParent() !== window
  //   ? WindowFunc.getTop()
  //   : window;
};
const getCurrentJQuery = () => {
  const currentWindow = getCurrentWindow();
  return currentWindow.$ || currentWindow.jQuery;
};
export const viewer = e => {
  let source = e.target;
  const owner = source.ownerDocument.getElementsByClassName("formImgPlay");
  const currentWindow = getCurrentWindow();
  const windowEcCom = currentWindow.ecCom;
  let load = windowEcCom ? windowEcCom.WeaUpload.loadjs : loadjs;
  load.isDefined("imcarouselJS")
    ? load.ready("imcarouselJS", function() {
        // 图片轮播
        const jq = getCurrentJQuery();
        const currentWindow = getCurrentWindow();
        const imgPool = [];
        let indexNum = 0;
        for (let i = 0; i < owner.length; i++) {
          imgPool.push(
            owner[i].getAttribute("data-imgsrc") || owner[i].getAttribute("src")
          );
        }
        for (let i = 0; i < imgPool.length; i++) {
          const imgSrc = !!jq(source).attr("data-imgsrc")
            ? jq(source).attr("data-imgsrc")
            : jq(source).attr("src");
          if (imgSrc === imgPool[i]) {
            break;
          } else {
            indexNum++;
          }
        }
        IMCarousel.showImgScanner4Pool(
          true,
          imgPool,
          indexNum,
          null,
          window.setLayoutWindow ? window.setLayoutWindow : WindowFunc.getTop()
        );
      })
    : load(
        [
          "/social/js/drageasy/drageasy.js",
          "/social/js/bootstrap/js/bootstrap.js",
          "/social/im/js/IMUtil_wev8.js",
          "/social/js/imcarousel/imcarousel.js"
        ],
        "imcarouselJS",
        function() {
          // 图片轮播
          const jq = getCurrentJQuery();
          const currentWindow = getCurrentWindow();
          const imgPool = [];
          let indexNum = 0;
          for (let i = 0; i < owner.length; i++) {
            imgPool.push(owner[i].getAttribute("data-imgsrc"));
          }
          for (let i = 0; i < imgPool.length; i++) {
            if (jq(source).attr("data-imgsrc") === imgPool[i]) {
              break;
            } else {
              indexNum++;
            }
          }
          IMCarousel.showImgScanner4Pool(
            true,
            imgPool,
            indexNum,
            null,
            window.setLayoutWindow
              ? window.setLayoutWindow
              : WindowFunc.getTop()
          );
        }
      );
};



// WEBPACK FOOTER //
// ./ecology9/wea-tools/viewer.js